import { AppState, AppStateStatus } from 'react-native';
import { startListening } from '../listenerMiddleware';
import {
  appActive,
  appInactive,
  appInBackground,
  appOpened,
  selectActivityStarted,
} from './app.slice';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';

export const APP_STATE_ACTIONS: Partial<
  Record<AppStateStatus, ActionCreatorWithPayload<AppStateStatus>>
> = {
  active: appActive,
  inactive: appInactive,
  background: appInBackground,
};

startListening({
  actionCreator: appOpened,
  effect: (_, { dispatch, getState }) => {
    let prevState = AppState.currentState;

    AppState.addEventListener('change', (state) => {
      const action = APP_STATE_ACTIONS[state];
      const isInactive = selectActivityStarted(getState());

      if (isInactive) {
        dispatch(APP_STATE_ACTIONS.inactive!(state));
      } else if (action) {
        dispatch(action(prevState));
      }

      prevState = state;
    });
  },
});
